import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Icon from '@projeccions-pdc/react-icon';
import Tooltip from '@material-ui/core/Tooltip';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
// import DeleteIcon from '@material-ui/icons/Delete';
// import FilterListIcon from '@material-ui/icons/FilterList';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import LocalizedStrings from '../../Localization/localization';

const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    spacer: {
        flex: '1 1 100%',
    },
    action: {
        display: 'inline-block',
        margin: '0px 5px',
    },
    actions: {
        color: theme.palette.text.secondary,
        width: '100%',
        textAlign: 'right',
    },
    title: {
        flex: '0 0 auto',
    },
    margin: {
        margin: theme.spacing(1)
    },
    textField: {
        flexBasis: 200
    }
});

let EnhancedTableToolbar = props => {
    const { numSelected, classes } = props;

    return (
        <Toolbar
            className={classNames(classes.root, {
                [classes.highlight]: numSelected > 0,
            })}
        >
            <div className={classes.title}>
                {numSelected > 0 ?
                    (
                        <Typography color='inherit' variant='subtitle1'>
                            {`${numSelected} selected`}
                        </Typography>
                    )
                    :
                    (
                        <Typography variant='h6' id='tableTitle'>
                            {props.tableTitle}
                        </Typography>
                    )}
            </div>
            <div className={classes.spacer} />
            <div className={classes.actions}>
                {numSelected > 0 ?
                    props.actions.map((action) => {
                        return (
                            <div key={action.action} className={classes.action}>
                                <Button variant="outlined" onClick={() => props.handleAction(action.onAction)}>
                                    {action.icon ?
                                        <Icon
                                            name={action.icon}
                                            size={'20px'}
                                        />
                                        : ''}
                                    {` ${action.action}`}
                                </Button>
                            </div>
                        );
                    })
                    :
                    <div>
                        <Tooltip title='Filter list'>
                            <FormControl className={classNames(classes.margin, classes.textField)}>
                                <InputLabel htmlFor='adornment-password'>{'Search'}</InputLabel>
                                <Input
                                    id='adornment-password'
                                    type={'text'}
                                    value={props.searchValue}
                                    onChange={props.handleSearchValueChange}
                                    endAdornment={
                                        <InputAdornment position='end'>
                                            <Icon name='md-search' />
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                        </Tooltip>
                        <Button variant='outlined' onClick={props.handleExportData}>{LocalizedStrings.exportData}</Button>
                    </div>
                }
            </div>
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    tableTitle: PropTypes.string.isRequired,
    searchValue: PropTypes.string.isRequired,
    handleSearchValueChange: PropTypes.func.isRequired,
    actions: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]),
    handleAction: PropTypes.func.isRequired,
    handleExportData: PropTypes.func.isRequired,
};

export default withStyles(toolbarStyles)(EnhancedTableToolbar);
